import React from "react";
import { useTheme } from "styled-components";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteForgeNarrativeLoader = React.lazy(() =>
    import("adsForgeMfc/NarrativeLoader").then((module) => ({
        default: module.NarrativeLoaderMFC,
    })),
) as React.FC<any>;

export const ForgeNarrativeLoader: React.FC<any> = (props) => {
    const theme = useTheme();

    return (
        <RemoteComponentWrapper>
            <RemoteForgeNarrativeLoader {...props} theme={theme} />
        </RemoteComponentWrapper>
    );
};
